var moduleMap = {
	"./Layout": () => {
		return Promise.all([__webpack_require__.e(736), __webpack_require__.e(176), __webpack_require__.e(591), __webpack_require__.e(573), __webpack_require__.e(35), __webpack_require__.e(57), __webpack_require__.e(239), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(833), __webpack_require__.e(241), __webpack_require__.e(255), __webpack_require__.e(620)]).then(() => (() => ((__webpack_require__(72620)))));
	},
	"./AppRoutes": () => {
		return Promise.all([__webpack_require__.e(736), __webpack_require__.e(176), __webpack_require__.e(591), __webpack_require__.e(573), __webpack_require__.e(35), __webpack_require__.e(57), __webpack_require__.e(239), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(833), __webpack_require__.e(241), __webpack_require__.e(255), __webpack_require__.e(625)]).then(() => (() => ((__webpack_require__(39625)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});